<template>
  <div>
    <FindId></FindId>
  </div>
</template>

<script>
import FindId from "@/components/shoplus_service/partners/FindId.vue";

export default {
  components: {
    FindId,
  },
};
</script>
